// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z8H1","content":"styles_content__3LZuX","tableWrap":"styles_tableWrap__2JWZW"};